export const SESSION_STORAGE_HOME_AFASTAMENTO_DONE =
  'homePopup_afastamento_sessionDone';

export function clearHomeAfastamentoPopupSession(): void {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_HOME_AFASTAMENTO_DONE);
  } catch {
    // ignore
  }
}
